import { baseDatapointFieldSchema } from './datapointField.schema';

export const datapointFieldSchema = baseDatapointFieldSchema?.transform(m => ({
  ...m,
  __kind: 'Datapoint' as const,
}));
